import React, { useEffect, useRef } from "react";

function Ambient() {
  const barRef = useRef(null);
  const glowRef = useRef(null);

  useEffect(() => {
    let frame = null;

    const updateBar = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const progress = max > 0 ? window.scrollY / max : 0;
      if (barRef.current) {
        barRef.current.style.transform = `scaleX(${progress})`;
      }
    };

    const moveGlow = (e) => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        if (glowRef.current) {
          glowRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
          glowRef.current.style.opacity = 1;
        }
        frame = null;
      });
    };

    updateBar();
    window.addEventListener("scroll", updateBar, { passive: true });
    window.addEventListener("resize", updateBar);
    const finePointer = window.matchMedia("(pointer: fine)").matches;
    if (finePointer) {
      window.addEventListener("mousemove", moveGlow);
    }

    return () => {
      window.removeEventListener("scroll", updateBar);
      window.removeEventListener("resize", updateBar);
      window.removeEventListener("mousemove", moveGlow);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <>
      <div ref={barRef} className="scroll-progress" aria-hidden="true"></div>
      <div ref={glowRef} className="cursor-glow" aria-hidden="true"></div>
    </>
  );
}

export default Ambient;
